import {
  CursorPaginationSchema,
  api,
  apiEndpoint,
  cursorPaginatedResponse,
} from "@core/ports/http";
import { z } from "@core/zod";

import { API_DOMAIN } from "@platform/core";

import { BILLING_SERVICE } from "../config/index.ts";
import { Balance, Transaction } from "../models/index.ts";

export const billingApi = api(
  { domain: API_DOMAIN, path: `${BILLING_SERVICE.LABEL}/api` },
  {
    getMyBalance: apiEndpoint({
      response: z.object(
        {
          available: z.decimal(),
          balances: z.array(Balance.schema),
          reserved: z.decimal(),
          total: z.decimal(),
        },
        {
          available: "The credit left to spend, the total less the reserved",
          balances: "The signed-in user's active balances",
          reserved: "The credit the pending reservations hold",
          total: "The credit the active balances hold together",
        },
      ),
    }),
    getMyTransactions: apiEndpoint({
      body: CursorPaginationSchema,
      response: cursorPaginatedResponse(Transaction.schema),
    }),
  },
);
